<template>
    <div class="card">
      <div class="card-header header-elements-inline">
        <legend class="font-weight-semibold text-uppercase font-size-sm">
          <i class="icon-file-text2"></i>
          Enter Vehicle information
        </legend>

        <div class="header-elements">
          <div class="list-icons">
            <a class="list-icons-item" data-action="reload"></a>
            <a class="list-icons-item" data-action="remove" @click="closeWindow"></a>
          </div>
        </div>
      </div>

      <div class="card-body">

        <div class="form-group row">
          <label class="col-md-3 col-form-label">Cateogry:</label>
          <div class="col-md-9">
            <select id="txtname" class="form-control" v-if="vehicle" v-model="vehicle.category.code" >
              <option v-for="group in categories" v-bind:value="group.code">
                {{ group.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-3 col-form-label">Vehicle No:</label>
          <div class="col-md-9">
            <input type="text" class="form-control" placeholder="Vehicle No" v-if="vehicle" v-model="vehicle.name">
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-3 col-form-label">ODO Mtr:</label>
          <div class="col-md-9">
            <input type="number" class="form-control" placeholder="Open ODO Meter" v-if="vehicle" v-model="vehicle.odometer" maxlength="14" >
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-3 col-form-label">Owner:</label>
          <div class="col-md-9">

            <select class="form-control" v-if="vehicle" v-model="vehicle.buyer.code" >
              <option v-for="group in owners" v-bind:value="group.code">
                {{ group.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="text-right">
          <button type="submit" class="btn btn-outline alpha-success text-success-800 border-success-600 legitRipple" @click="saveDocument">Save <i class="icon-paperplane ml-2"></i></button>
        </div>

      </div>
    </div>
</template>

<script>
import { userService } from '@/store/auth-header.js'
import { store } from '@/store/store.js'

export default {
  name: 'VehicleForm',
  store,
  data () {
    return {
      categories:[],
      owners:[],
      vehicle: JSON.parse('{"_id":"","code":0,"active":"Y","name":"","type":0,"odometer":0,"category":{"_id":"","code":0,"name":"","type":0},"buyer":{"_id":"","code":0,"status":0,"type":0,"name":"","alias":"","open_bal":0,"gstin":"","add":{"name":"","street":"","city":"","pin":"","state_cd":0,"email":"","tel":"","mobile":""}}}')
    }
  },
  component: {

  },
  props: {
    myvehicle: {
      type: Object,
      required: true,
      default: JSON.parse('{"_id":"","code":0,"active":"Y","name":"","type":0,"odometer":0,"category":{"_id":"","code":0,"name":"","type":0},"buyer":{"_id":"","code":0,"status":0,"type":0,"name":"","alias":"","open_bal":0,"gstin":"","add":{"name":"","street":"","city":"","pin":"","state_cd":0,"email":"","tel":"","mobile":""}}}')
    }
  },
  beforeMount () {
    this.vehicle = this.myvehicle; // save props data to itself's data and deal with it
  },
  created () {
    this.$data.vehicle = JSON.parse('{"_id":"","code":0,"active":"Y","name":"","type":0,"odometer":0,"category":{"_id":"","code":0,"name":"","type":0},"buyer":{"_id":"","code":0,"status":0,"type":0,"name":"","alias":"","open_bal":0,"gstin":"","add":{"name":"","street":"","city":"","pin":"","state_cd":0,"email":"","tel":"","mobile":""}}}')
  },
  mounted () {
    $('.form-control-select2').select2();
    this.loadCategories();
    this.loadOwners();
    $('#txtname').focus();
  },
  methods: {
    closeWindow () {
      this.$emit('vehicle_window_closed');
    },
    loadCategories () {
      const self = this;

      const requestOptions = {
        method: 'GET',
        mode: 'cors',
        headers: userService.authHeader()
      }


      self.categories = [];
      fetch(`${process.env.VUE_APP_ROOT_API}api/v1/xbunk/vehiclecategory/`, requestOptions).then(userService.handleResponse).then(function (resp) {
        if (resp.accepted) {
          if (_.isArray(resp.data)) {
            self.$data.categories = resp.data;
          }
        } else {
          swal({ title: 'Oops!', text: resp.msg, type: 'error' });
        }
      }).catch(function (err) {
        swal({ title: 'Oh noes!', text: err.toString(), type: 'error' });
      })
    },
    loadOwners () {
      const self = this;

      const requestOptions = {
        method: 'GET',
        mode: 'cors',
        headers: userService.authHeader()
      }


      fetch(`${process.env.VUE_APP_ROOT_API}api/v1/xpos/buyer/`, requestOptions).then(userService.handleResponse).then(function (resp) {
        if (resp.accepted) {
          if (_.isArray(resp.data)) {
            self.$data.owners = resp.data;
          }
        } else {
          swal({ title: 'Oops!', text: resp.msg, type: 'error' });
        }
      }).catch(function (err) {
        swal({ title: 'Oh noes!', text: err.toString(), type: 'error' });
      });
    },
    saveDocument () {
      const self = this;

      if (self.$data.vehicle.name.toString().length < 7) {
        alert('Invalid Vehicle No');
        return
      }


      self.$data.vehicle.odometer = parseInt(self.$data.vehicle.odometer);

      if(self.$data.vehicle.code == 0){
        self.$data.vehicle.buyer.code = 1;
      }

      const requestOptions = {
        method: (self.$data.vehicle.code == 0 ? 'POST' : 'PUT'),
        mode: 'cors',
        headers: userService.authHeader(),
        body: JSON.stringify(self.$data.vehicle)
      }

      fetch(`${process.env.VUE_APP_ROOT_API}api/v1/xbunk/vehicle/`, requestOptions).then(userService.handleResponse).then(function (resp) {
        if (resp.accepted) {
          swal({ title: 'Success!', text: resp.msg, type: 'success' });
          self.vehicle = JSON.parse('{"_id":"","code":0,"active":"Y","name":"","type":0,"odometer":0,"category":{"_id":"","code":0,"name":"","type":0},"buyer":{"_id":"","code":0,"status":0,"type":0,"name":"","alias":"","open_bal":0,"gstin":"","add":{"name":"","street":"","city":"","pin":"","state_cd":0,"email":"","tel":"","mobile":""}}}');
          self.$emit('vehicle_saved',resp.data);
        } else {
          swal({ title: 'Oops!', text: resp.msg, type: 'error' });
        }
      }).catch(function (err) {
        swal({ title: 'Oh noes!', text: err.toString(), type: 'error' });
      })
    }
  }
}
</script>

<style scoped>

</style>
